<template>
    <div class="bslip-item fadeInUp" :class="itemStatus" ref_testcafe="frontendSelectedMatches">
        <div class="bslip-item-left" v-if="betslip.betslipDef == 'combination'">
          <i class="icon-fix iconset bslip-fixicon" v-on:click="betslip.changeItemFix(item)" :class="(item.fix ? 'active' : '')"></i>
        </div>
        <div class="bslip-teams">
            <p class="bslip-teams-names" v-if="item.type === 'sport'">{{item.eventName}}</p>
            <p class="bslip-teams-names" v-else v-html="itemName"></p>
            <p class="bslip-game-part">{{itemMarketName}}{{getModifier}}</p>
        </div>
        <div class="bslip-item-right">
            <div class="bslip-odds-container">
                <div class="bslip-odd-type">{{itemOutcomeName}}</div>
                <div class="bslip-odd-value">
                    <span class="odd-change-old" v-if="getPrevOdd && checkOddChange">{{ getPrevOdd | formatOdd}}</span>
                    {{item.meta.coefficient | formatOdd}}
                </div>
            </div>
            <p class="bslip-item-date" :class="{'live': item.meta.live}">
                <span>
                    {{$formatTicketMatchDate(item, 'DD.MM. HH:mm')}}
                </span>
                <span v-if="getPrevOdd && checkOddChange">
                    <img src="../../../assets/img/icon-oddchange-up.svg" class="ticket-odd-change" v-if="checkOddChange === 'oddIncreased'"/>
                    <img src="../../../assets/img/icon-oddchange-down.svg" class="ticket-odd-change" v-else-if="checkOddChange === 'oddDecreased'"/>
                </span>
                </p>
        </div>
        <div v-if="isMobile" class="mtitem-delete" v-on:click="selectBetslipOutcome(item)">
          <div class="mtitem-dlt-button">
            <i class="iconset icon-delete"></i>
          </div>
        </div>
        <div class="titem-delete" v-on:click="selectBetslipOutcome(item)">
          <div class="titem-dlt-button">
            <i class="iconset icon-delete"></i>
          </div>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';

export default {
    name: 'BetslipItem',
    props: ['item', 'itemIndex'],
    methods: {
        ...mapActions([
            'selectBetslipOutcome',
        ]),
    },
    computed:
    {
        ...mapGetters([
            'isMobile',
            'globals',
            'betslip',
        ]),
        getPrevOdd()
        {
            const me = this;
            if (me.item
            && me.item.meta
            && me.item.meta.initialCoefficient)
            {
                return me.item.meta.initialCoefficient;
            }
            return false;
        },
        checkOddChange()
        {
            const me = this;
            if (me.item
            && me.item.meta
            && me.item.meta.initialCoefficient)
            {
                if (me.item.meta.initialCoefficient < me.item.meta.coefficient)
                {
                    return 'oddIncreased';
                }
                if (me.item.meta.initialCoefficient > me.item.meta.coefficient)
                {
                    return 'oddDecreased';
                }
            }
            return false;
        },
        itemStatus()
        {
            const me = this;

            let status = 'is-unavailable';

            if (me.item.status === undefined || me.item.status === '' || me.item.status === 'active')
            {
                status = 'is-active';
            }
            if (me.item.status === 'block')
            {
                status = 'is-blocked';
            }

            return status;
        },
        itemMarketName()
        {
            const me = this;

            if (me.item.type === 'vhorse')
            {
                return me.item.meta.marketName;
            }

            let field = 'marketName';

            if (me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventMarket != null)
            {
                field = me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventMarket;
            }

            if (field === 'both')
            {
                let textOut = me.item.meta.marketName;

                if (me.item.meta.marketShortName != null)
                {
                    textOut += ` (${me.item.meta.marketShortName})`;
                }

                return textOut;
            }

            if (me.item.meta[field] != null)
            {
                return me.item.meta[field];
            }

            return me.item.meta.marketName;
        },
        itemOutcomeName()
        {
            const me = this;

            if (me.item.type === 'vhorse')
            {
                return me.item.meta.outcomeName;
            }

            let field = 'outcomeName';

            if (me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventOutcome != null)
            {
                field = me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventOutcome;
            }

            if (field === 'both')
            {
                let textOut = me.item.meta.outcomeName;

                if (me.item.meta.outcomeShortName != null)
                {
                    textOut += ` (${me.item.meta.outcomeShortName})`;
                }

                return textOut;
            }

            if (me.item.meta != null
            && me.item.meta[field] != null)
            {
                return me.item.meta[field];
            }

            return me.item.meta.outcomeName;
        },
        getModifier()
        {
            const me = this;
            let modifier = '';

            if (me.item.type !== 'sport')
            {
                return modifier;
            }

            if (me.item.meta != null
            && me.item.meta.hasModifier === 1)
            {
                modifier = ` (${me.item.meta.modifierName}: ${me.item.meta.modifierValue})`;
            }

            return modifier;
        },
        itemName()
        {
            const me = this;

            let name = me.item.eventName;

            if (me.item.type === 'vhorse'
            && me.item.meta != null
            && me.item.meta.dailyInstanceId != null)
            {
                name = `(${me.item.meta.dailyInstanceId}) ${name}`;
            }

            return name;
        },
    },
};
</script>
